import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import { useComposableDashboardsFiltersContext } from '../../../../analyticsPage/hooks/useComposableDashboardsFiltersContext';
import usePostgreJobWidgetsData from '../../../hooks/usePostgreJobWidgetsData';
import {
  navigateToListingPage,
  barChartData,
  getFilterNameValue,
  chartSeriesDataType,
} from '../../helper';
import { IPostgreJobsDTO, IPostgreJobsWidgetProp } from '../types';
import { defaultJobsWidgetData } from '../utils/jobsHelper';

const JobsBarChartPostgre = ({ query, title, widgetName }: IPostgreJobsWidgetProp) => {
  const { widgetData } = usePostgreJobWidgetsData<IPostgreJobsDTO>(query, defaultJobsWidgetData);
  const { restructuredFilters } = useComposableDashboardsFiltersContext();

  const { barData, stacked } = barChartData(widgetName, widgetData, query);

  const options: ApexOptions = {
    chart: {
      ...(stacked && { stacked: true, height: '70%' }),
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      events: {
        dataPointMouseEnter: (event) => {
          const targetElement = event.target;
          targetElement.style.cursor = 'pointer';
        },
        dataPointMouseLeave: (event) => {
          const targetElement = event.target;
          targetElement.style.cursor = 'default';
        },
        click: (_event, _chartContext, config) => {
          if (config.dataPointIndex == -1) return;
          const series: ApexAxisChartSeries[number] = config.config.series[config.seriesIndex];
          const seriesData = series.data[config.dataPointIndex] as chartSeriesDataType;
          navigateToListingPage(
            seriesData,
            restructuredFilters,
            getFilterNameValue(widgetName, seriesData),
            query
          );
        },
      },
    },
    xaxis: {
      type: 'datetime',
      title: {
        text: title,
      },
      labels: {
        datetimeUTC: false,
      },
      categories: barData.categories,
    },
    yaxis: {
      title: {
        text: 'Count',
      },
    },
    ...(stacked && {
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 50,
      },
      stroke: {
        width: 1,
      },
    }),
    dataLabels: {
      enabled: false,
    },
    title: {
      text: title,
      style: {
        fontSize: '12px',
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={barData.series}
      type="bar"
      width="100%"
      height="100%"
    />
  );
};

export default JobsBarChartPostgre;
